import { useState } from "react";
import { Tabs, TabsProps } from "antd";
import { Button } from "antd";

import {
  BankOutlined,
  BarChartOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import { useModal } from "../../../hooks";
import { PageHeader } from "../../../components/PageHeader";
import { Content } from "../../../components/Content";
import { FinancialModal } from "../components/FinancialModal";

import { Receipt } from "./Receipt";
import { Payment } from "./Payment";

const Financial = () => {
  const [load, setLoad] = useState(false);

  const handleRefreshData = () => {
    setLoad(!load);
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Contas a receber",
      children: <Receipt load={load} handleRefreshData={handleRefreshData} />,
      icon: <BarChartOutlined />,
    },
    {
      key: "2",
      label: "Contas a pagar",
      children: <Payment load={load} handleRefreshData={handleRefreshData} />,
      icon: <BankOutlined />,
    },
  ];

  const { isOpen, handleCloseModal, handleOpenModal } = useModal();

  return (
    <>
      <PageHeader
        title="Financeiro"
        backButton={false}
        actions={[
          <Button
            icon={<PlusOutlined />}
            type="primary"
            onClick={() => handleOpenModal()}
          >
            Cadastrar conta
          </Button>,
        ]}
        crumb
      />

      <FinancialModal
        isModalOpen={isOpen}
        onClose={handleCloseModal}
        onRefreshData={handleRefreshData}
      />

      <Content width="calc(100% - 48px)" margin>
        <Tabs defaultActiveKey="1" items={items} />
      </Content>
    </>
  );
};

export { Financial };
